module.exports = __webpack_public_path__ + "img/solution-hmi-system-pic02.90445bd5.png";